import { AppAction } from '../actions';
import { ActionTypes } from './actionTypes';

export interface MapState {
  isLoaded: boolean;
}

const initialState: MapState = {
  isLoaded: false
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action: AppAction<any>): MapState => {
  switch (action.type) {
    case ActionTypes.SET_GOOGLE_MAPS_IS_LOADED: {
      return {
        ...state,
        isLoaded: action.payload
      };
    }

    default:
      return state;
  }
};
